import { Constants } from '../constants'

const TokenService = {

    getToken() {
        return localStorage.getItem(Constants.TOKEN_KEY)
    },

    storeToken(token) {
        localStorage.setItem(Constants.TOKEN_KEY, token)
    },

    storeRefreshToken(refreshToken) {
        localStorage.setItem(Constants.REFRESH_TOKEN_KEY, refreshToken)
    },

    invalidateToken() {
        localStorage.removeItem(Constants.TOKEN_KEY)
        localStorage.removeItem(Constants.REFRESH_TOKEN_KEY)
    }

}

export { TokenService }